mainApp.directive('topsList', function() {
	return {
		templateUrl: '/public/directives/topsList.html',
		scope: {
			item: '=',
			type: '@',
		}
	}
});